import { Factory } from 'rosie';

Factory.define('UserLogin').attr('name', 'USER_LOGIN');

Factory.define('UserLoginWithDefaults').extend('UserLogin');



// WEBPACK FOOTER //
// ./factories/location/user_login.js